import Service from '../AuthService';

const CustomerType = {
  getAllCustomerTypes() {
    return Service.get(`customer-types`);
  }
};

export default CustomerType;
